/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

import React from 'react';
import { OUI_THEMES } from '../../../../src/themes';
// @ts-ignore importing from a JS file
import { applyTheme } from '../../services';
var THEME_NAMES = OUI_THEMES.map(function (_ref) {
  var value = _ref.value;
  return value;
});
var defaultState = {
  theme: THEME_NAMES[3],
  changeTheme: function changeTheme(themeValue) {
    applyTheme(themeValue);
  }
};
export var ThemeContext = /*#__PURE__*/React.createContext(defaultState);
export class ThemeProvider extends React.Component {
  constructor(props) {
    super(props);
    let theme = localStorage.getItem('theme');
    if (!theme || !THEME_NAMES.includes(theme)) theme = defaultState.theme;
    applyTheme(theme);
    this.state = {
      theme
    };
  }
  changeTheme = themeValue => {
    this.setState({
      theme: themeValue
    }, () => {
      localStorage.setItem('theme', themeValue);
      applyTheme(themeValue);
    });
  };
  render() {
    const {
      children
    } = this.props;
    const {
      theme
    } = this.state;
    return <ThemeContext.Provider value={{
      theme,
      changeTheme: this.changeTheme
    }}>
        {children}
      </ThemeContext.Provider>;
  }
}